import * as React from "react";
import { SVGProps, memo } from "react";
const SvgVirtualConnectionTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    role="img"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#BFBFBF"
        d="M6 4v1h4V4h1v1h4v1h-4v1h4v1h-4v1h-1V8H6v1H5V8H1V7h4V6H1V5h4V4h1Zm4 2H6v1h4V6Z"
      />
      <path
        fill="#666"
        d="M7.5 15a1.5 1.5 0 0 1-1.374-.898l-.04-.101L2 14v-1l4.086-.001-.01.028c.146-.439.489-.788.924-.942V10H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H8v2.086c.436.154.778.502.924.941L8.914 13 14 13v1H8.914l.008-.022A1.5 1.5 0 0 1 7.5 15Zm0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM15 4H1v5h14V4Zm0-2H1v1h14V2Z"
      />
    </g>
  </svg>
);
const Memo = memo(SvgVirtualConnectionTable);
export default Memo;
